import PageTitle from '../../components/PageTitle'
import ExternalShadowRunTab from './ExternalShadowRunTab'

/**
 * PACE → External Shadow Run. Scores a not-yet-onboarded merchant's order book
 * through the real PACE allocator, with the candidate set, zones and rate-card prices
 * reconstructed from PACE's own lake. Pre-sales tool; Internal/Tools only.
 */
export default function ExternalShadowRunPage() {
  return (
    <div>
      <PageTitle>PACE · External Shadow Run</PageTitle>
      <ExternalShadowRunTab />
    </div>
  )
}
